import axios from "axios";
export default axios.create({
   //  baseURL: "http://localhost:3001/",
   // baseURL: 'http://146.190.240.142:3001/',  // Usando o domínio HTTPS
   baseURL: "https://api.alfaleiloessistema.com/"
});
